import { Receipt } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import * as m from '~/paraglide/messages'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { CompanyDetailsForm } from './company-details-form'
import { COMPANY_DETAILS_ANCHOR, useCanEditCompanyDetails } from './use-can-edit-company-details'

/** The company details in Einstellungen, for the owner and Pulsify admins. */
export function CompanyDetailsCard({ className }: { className?: string }) {
  const { data: business } = useCurrentBusiness()
  const canEdit = useCanEditCompanyDetails()
  if (!business || !canEdit) return null

  return (
    <Card id={COMPANY_DETAILS_ANCHOR} className={className}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Receipt className="h-5 w-5" />
          {m.companyDetailsTitle()}
        </CardTitle>
        <CardDescription>{m.companyDetailsSubtitle()}</CardDescription>
      </CardHeader>
      <CardContent>
        <CompanyDetailsForm key={business.id} business={business} />
      </CardContent>
    </Card>
  )
}
